import React from "react";
import ApplicationLogo from '../ApplicationLogo';
import { Section } from '../Section';

export function Footer() {
  return (
    <div className="tw-bg-primary tw-text-white">
      <Section>
        <div className="tw-grid tw-grid-cols-1 tw-gap-8 tw-pb-8 md:tw-grid-cols-4 lg:tw-grid-cols-6">
          <div className="md:tw-col-span-4 lg:tw-col-span-2">
            <ApplicationLogo className="tw-text-white" />
            <p>Powered by POD SecurePay</p>
          </div>

          <div className="tw-flex tw-flex-col tw-space-y-4">
            <h4 className="tw-text-white">Services</h4>
            <a href={'/seller'}>Seller</a>
            <a href={'/buyer'}>Buyer</a>
            <a href={'/secure-pay'}>SecurePay</a>
          </div>

          <div className="tw-flex tw-flex-col tw-space-y-4">
            <h4 className="tw-text-white">Company</h4>
            <a href={'/about-us'}>About Us</a>
            <a href={'/partnership'}>
              Affiliates and Partnerships
            </a>
          </div>

          <div className="tw-flex tw-flex-col tw-space-y-4">
            <h4 className="tw-text-white">Help and Support</h4>
            <a href={'/help-center'}>FAQ</a>
            <a href={'/help-center'}>Help Centre</a>
          </div>

          <div className="tw-flex tw-flex-col tw-space-y-2">
            <h4 className="tw-text-white">Legal</h4>
            <a href={'/privacy-policy'}>Privacy Policy</a>
            <a href={'/terms-and-conditions'}>Terms & Conditions</a>
          </div>
        </div>

        <hr className="tw-border-gray-50 tw-opacity-50" />

        <div className="tw-flex tw-flex-col tw-gap-8 tw-pt-8 md:tw-flex-row md:tw-items-center md:tw-justify-between">
          <p>© {new Date().getFullYear()} PayOnDelivery Inc.</p>

          <div className="tw-flex tw-flex-col tw-gap-8 md:tw-flex-row md:tw-items-center">
            <p>Reach Us</p>
            <div className="tw-flex tw-justify-between tw-gap-8">
              {[
                { url: '', icon: 'twitter.png', alt: 'POD Twitter' },
                { url: 'https://www.facebook.com/payondelivery', icon: 'facebook.png', alt: 'POD Facebook' },
                // { url: '', icon: 'youtube.png', alt: 'POD Youtube' },
                { url: 'https://www.Linkedin.com/company/payondelivery/', icon: 'linked_in.png', alt: 'POD LinkedIn' },
                { url: 'https://www.instagram.com/payondelivery', icon: 'instagram.png', alt: 'POD Instagram' }
              ].map((social, index) => (
                <a key={index} href={social.url} target="_blank">
                  {' '}
                  <img
                    src={`/assets/images/social-icons/${social.icon}`}
                    alt={social.alt}
                  />{' '}
                </a>
              ))}
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}
